import React, { useContext, useState } from 'react';

import Tabs from '../../common_components/InnerTabs';
import Layout from '../../common_components/Layout';
import {
  PlotAdjustForm,
  ExportForm,
  ExportFormCsvOnly,
} from '../components/Forms';
import { SvgPlot } from '../../common_components/SvgPlot';
import { AppContext } from '../contexts';
import { SearchableTable } from '../../common_components/SearchableTable';

export default function ModelEvaluation({ data, name }) {
  const initialTab = 'evaluationmetrics';
  const app = useContext(AppContext);

  const [isLoading, setIsLoading] = useState(true);
  const [selectedVisualization, setSelectedVisualization] =
    useState(initialTab);
  const [visualizationData, setVisualizationData] = useState({
    evaluationmetrics: null,
    scatterplot: null,
    meanplot: null,
  });

  const formSubmitRequest = (formData) =>
    app.APIs.steps.visualization(
      app.activeProject.id,
      name,
      selectedVisualization,
      app.activeProject.filehash,
      formData,
    );
  const onFormSubmitSuccess = (data) => {
    setVisualizationData((p) => ({
      ...p,
      [selectedVisualization]: data,
    }));
  };

  return (
    <Layout
      title="Ocena Modelu"
      sideContent={
        <>
          {data && (
            <PlotAdjustForm
              fieldsData={data['form_data'][`${selectedVisualization}`]}
              formSubmitRequest={formSubmitRequest}
              onSubmitSuccess={onFormSubmitSuccess}
              isLoading={isLoading}
              setPlotIsLoading={setIsLoading}
              autoSubmit
            />
          )}
          {selectedVisualization == 'evaluationmetrics' ? (
            <ExportFormCsvOnly
              csvData={visualizationData['evaluationmetrics']}
              isLoading={isLoading}
            />
          ) : (
            <ExportForm
              svgBlob={visualizationData[selectedVisualization]}
              isLoading={isLoading}
            />
          )}
        </>
      }
      mainContent={
        <>
          <Tabs
            tabs={[
              {
                label: 'Metryki Oceny',
                content: visualizationData['evaluationmetrics'] && (
                  <SearchableTable
                    data={visualizationData['evaluationmetrics']}
                  ></SearchableTable>
                ),
                onClick: () => setSelectedVisualization('evaluationmetrics'),
                defaultChecked: initialTab == 'evaluationmetrics',
              },
              {
                label: 'Scatter Plot',
                content: visualizationData['scatterplot'] && (
                  <SvgPlot imgBlob={visualizationData['scatterplot']}></SvgPlot>
                ),
                onClick: () => setSelectedVisualization('scatterplot'),
                defaultChecked: initialTab == 'scatterplot',
              },
            ]}
            isLoading={isLoading}
          ></Tabs>
        </>
      }
    ></Layout>
  );
}
